import { createPaginatedEndpoint } from "utils/services.util";

import { PaginatedResponse } from "./common";
import { emptySplitApi } from "./empty-split-api";
import {
  EmailFilters,
  EmailResponse,
  PatchEmailAttach,
  SendEmailInput
} from "./types/email.type";
import type {
  MassEmailResponse,
  SendEmailResponse,
  UploadFileRequest,
  UploadFileResponse
} from "./types/emails.type";

const emailsApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    sendEmail: builder.mutation<
      SendEmailResponse | MassEmailResponse,
      SendEmailInput
    >({
      query: (data) => {
        return {
          url: "/emails/",
          method: "POST",
          body: data
        };
      }
    }),
    attachFilesToEmails: builder.mutation<SendEmailResponse, PatchEmailAttach>({
      query: ({ ids, should_send, files }) => {
        const formData = new FormData();
        formData.append("should_send", String(should_send));
        ids.forEach((id) => {
          formData.append(`ids`, String(id));
        });
        files.forEach((file) => {
          formData.append(`files`, file);
        });

        return {
          url: "/emails/attach/",
          method: "PATCH",
          body: formData
        };
      }
    }),
    getEmailsPaginated: createPaginatedEndpoint<EmailFilters, EmailResponse[]>(
      builder,
      {
        queryFn: (params) => ({
          url: "/emails/",
          params
        }),
        providesTags: ["Emails"],
        transformResponseFn: (response: PaginatedResponse<EmailResponse>) =>
          response.results
      }
    ),
    uploadFile: builder.mutation<UploadFileResponse, UploadFileRequest>({
      query: ({ content, extension }) => {
        if (typeof content === "string") {
          return {
            url: "/emails/upload-file/",
            method: "POST",
            body: {
              content,
              extension
            }
          };
        } else {
          const formData = new FormData();
          formData.append("content", new File([content], "file." + extension));
          formData.append("extension", extension);
          return {
            url: "/emails/upload-file/",
            method: "POST",
            body: formData
          };
        }
      }
    })
  })
});

export const {
  useSendEmailMutation,
  useAttachFilesToEmailsMutation,
  useGetEmailsPaginatedQuery,
  useUploadFileMutation
} = emailsApi;
